// extracted by mini-css-extract-plugin
module.exports = {"iconEffect":"vA","iconInPlayer":"vB"};